import React from 'react';
import { Button } from '../../ui/Button';
import { Select } from '../../ui/Select';
interface PoliticalExposureScreenProps {
  isPoliticallyExposed: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function PoliticalExposureScreen({
  isPoliticallyExposed,
  onChange,
  onNext,
  onBack
}: PoliticalExposureScreenProps) {
  const isValid = isPoliticallyExposed !== '';
  const options = [{
    value: 'no',
    label: 'No, I am not politically exposed'
  }, {
    value: 'yes',
    label: 'Yes, I am a politically exposed person'
  }];
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-245">
      <div className="flex-1" data-id="element-246">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-247">
          Political Exposure
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-248">
          Are you or any of your immediate family members considered a
          Politically Exposed Person (PEP)?
        </p>

        <div className="space-y-6" data-id="element-249">
          <Select label="Select your status" options={options} value={isPoliticallyExposed} onChange={e => onChange('isPoliticallyExposed', e.target.value)} data-id="element-250" />

          {isPoliticallyExposed === 'yes' && <div className="bg-amber-50 p-4 rounded-lg border border-amber-100 animate-in fade-in" data-id="element-251">
              <p className="text-sm text-amber-800" data-id="element-252">
                We may need to ask for a few additional details later in the
                process.
              </p>
            </div>}
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-253">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-254">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-255">
          Review
        </Button>
      </div>
    </div>;
}